import React from 'react';
import Page from "components/Page";
import Form, {FormBlock, FormSection, MediaField, SelectField} from "components/Form/Form";
import {DataImport, DataImportData} from "types/DataImport";
import {useMutation} from "react-query";
import ngage from "../../../services/ngage";
import {useNotifications} from "../../../context/NotificationContext";
import {useNavigate} from "react-router-dom";
import {FormikHelpers} from "formik";
import {invalidate} from "../../../services/query-client";
import {Type} from "../../../types/MediaFile";
import {DocumentIcon} from "@heroicons/react/outline";

// Component ----

function ImportTickets() {
  const {notify} = useNotifications();
  const navigate = useNavigate();

  const store = useMutation((data: DataImportData) => ngage.imports.store(data));

  async function submitImport(values: DataImportData, {setSubmitting}: FormikHelpers<DataImportData>) {
    let dataImport: DataImport | null = null;

    try {
      dataImport = await store.mutateAsync(values);
    } catch (error) {
      notify("error", "Ticket Import Not Submitted", "A new ticket import could not be submitted. Please try again later.")
      console.error(error)
    } finally {
      setSubmitting(false)
    }

    if (dataImport) {
      notify("success", "Ticket Import Submitted", "Your import will start as soon as possible.");
      await invalidate(["imports"])
      navigate(`/imports/${dataImport.id}`)
    }
  }

  const breadcrumbs = {
    'Engagement': '/',
    'Tickets': '/tickets',
    'Import Tickets': '/tickets/import'
  };

  const initialValues: DataImportData = {
    category: "tickets",
    source: "skiddle",
    file_id: 0,
  }

  const sourceOptions = [
    {id: "skiddle", name: "Skiddle"},
    {id: "ticketmaster", name: "Ticketmaster"},
    {id: "fareharbor", name: "FareHarbor"},
  ]

  return (
    <Page
      title={"Import Tickets"}
      breadcrumbs={breadcrumbs}
    >
      <Form
        initialValues={initialValues}
        onSubmit={submitImport}
      >
        <FormSection
          name={"Details"}
          description={"Provide details about the data to be imported"}
          columns={6}
        >
          <FormBlock columns={3}>
            <SelectField
              name={"source"}
              label={"Source *"}
              help={"This is where the data has come from"}
              options={sourceOptions}
              required
            />
          </FormBlock>

          <FormBlock columns={6}>
            <MediaField
              name={"file_id"}
              label={"File *"}
              type={Type.DOCUMENT}
              minFiles={1}
              maxFiles={1}
              icon={DocumentIcon}
            />
          </FormBlock>
        </FormSection>
      </Form>
    </Page>
  );
}

// Export ----

export default ImportTickets;